export class Person {

    id?: number;
    registerDate?: Date;
    name?: string;
    surname?: string;
    secondSurname?: string;

    constructor(source: Partial<Person>) {
        Object.assign(this, source);
    }
}
